import React from 'react'
import "./styles.css"
import telegram from "../assets/telegram.png"
import insta from "../assets/instagram.png"
import linkedin from "../assets/linkedin.png"
import { Link } from 'react-router-dom'

const Footer = ({ handleNavigation }) => {
    const data = [
        {
            name: "Instagram",
            link: "https://instagram.com/interncrafters",
            icon: "insta"
        },
        {
            name: "LinkedIn",
            link: "https://www.linkedin.com/in/intern-crafters-40b828300",
            icon: "linkedin"
        },
        {
            name: "Telegram",
            link: "https://t.me/interncrafters",
            icon: "telegram"
        }
    ]

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <footer className='footer'>
            <div className='footer-1-links'>
                <div className='footer-section'>
                    <div className='footer-heading' onClick={scrollToTop}><h5>About Us</h5></div>
                    <div className='footer-about'>
                        <span><button style={{ color: "white", padding: "0" }} className="nav-items-btn-2" onClick={() => handleNavigation('home')}>Home</button></span>
                        <span><button style={{ color: "white", padding: "0" }} className="nav-items-btn-2" onClick={() => handleNavigation('about')}>About</button></span>
                        <span><button style={{ color: "white", padding: "0" }} className="nav-items-btn-2" onClick={() => handleNavigation('internships')}>Internships</button></span>
                        <span><button style={{ color: "white", padding: "0" }} className="nav-items-btn-2" onClick={() => handleNavigation('faqs')}>FAQs</button></span>
                        {/* <span><button className="nav-items-btn" onClick={() => handleNavigation('contact')}>Contact</button></span> */}
                    </div>
                </div>
                <div className='footer-section'>
                    <div className='footer-heading' onClick={scrollToTop}><h5>Social</h5></div>
                    <div className='social-links'>
                        {data.map(links => <a className='link-tag' href={links.link}>
                            <div className='social-icons-div' >
                                <img className='social-icons' src={links.icon === "insta" ? insta : links.icon === "telegram" ? telegram : linkedin} alt="#" />
                                <span className='social-links-span'>{links.name}</span>
                            </div>
                        </a>
                        )}
                    </div>
                </div>
                <div className='footer-section'>
                    <div className='footer-heading' onClick={scrollToTop}><h5>Our Services</h5></div>
                    <span><button style={{ color: "white", padding: "0" }} className="nav-items-btn-2" onClick={() => handleNavigation('internships')}>Internships</button></span>
                </div>
                <div className='footer-section'>
                    <div className='footer-heading' onClick={scrollToTop}><h5>Other Info</h5></div>
                    <span>Address: Delhi, India</span>
                </div>
            </div>
            <div className="footer-2-links">
                <Link onClick={scrollToTop} className='link-decor2' to="/privacy-policy"><h6 style={{ cursor: "pointer" }}>Privacy Policy</h6></Link>
                <Link onClick={scrollToTop} className='link-decor2' to="/code-of-conduct"><h6 style={{ cursor: "pointer" }}>Code of Conduct</h6></Link>
                <Link onClick={scrollToTop} className='link-decor2' to="/terms-conditions"><h6 style={{ cursor: "pointer" }}>Terms & Conditions</h6></Link>
                <Link onClick={scrollToTop} className='link-decor2' to="/returns"><h6 style={{ cursor: "pointer" }}>Returns</h6></Link>
            </div>
        </footer >
    )
}

export default Footer
